import { StyleSheet } from "react-native";
import React from "react";

export function FloatingButtonContainer({
    shadow,
    children,
}: {
    shadow?: Boolean;
    children: React.ReactElement;
}) {
    return (
        <div
            style={StyleSheet.flatten([
                styles.floatingButtonContainer,
                shadow ? styles.shadow : null,
            ])}
        >
            {children}
        </div>
    );
}

const styles: { [key: string]: React.CSSProperties } = {
    floatingButtonContainer: {
        position: "sticky",
        bottom: 0,
        zIndex: 2,
    },

    shadow: {
        // matches a Button with size="normal"
        borderRadius: 32,

        // Matches a Button with shadow="shadow"
        boxShadow: "5px 5px 3.84px 0 rgba(0,0,0,0.3)",
    },
};
